import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ApiConstants } from '@app/api-constants';
import { AppGlobalService } from '@app/app-global.service';
import { EllipsisService } from '@app/ellipsis.service';
import { ModalPopupService } from '@app/shared/services/modal-popup.service';
import { NotificationService } from '@app/shared/services/notification.service';
import { VsFormComponent } from '@app/widget/vs-form/vs-form.component';
import { VsGridComponent } from '@app/widget/vs-grid/vs-grid.component';
import { AppConstants } from '@custom/core/app-constants';
import { CustomService } from '@custom/services/custom.service';
import SecurityJson from '@app/security/changelog/changelog.security';
@Component({
  selector: 'app-changelog-list',
  templateUrl: './changelog-list.component.html',
  styleUrls: ['./changelog-list.component.scss']
})
export class ChangelogListComponent implements OnInit {

  @ViewChild(VsFormComponent) child;
  public data = {};
  private dtTable: any;
  public formConfig: any;
  public customLog=true;
  @ViewChild(VsGridComponent)
  private gridComp: any = VsGridComponent;
  public gridConfig: any = {};
  private isPrototyping: boolean;
  local: any = {};
  public pageName = 'Change Log';
  filter: {};
  refreshGridMethod: () => void;

  dataChanged = (data) => {
    
  };
  public hasWorkflow = false;

  constructor(
    public appGlobal: AppGlobalService,
    public customService: CustomService,
    public element: ElementRef,
    public ellipsis: EllipsisService,
    public notification: NotificationService,
    public modalPopupService: ModalPopupService,
  ) { 


  }
  @ViewChild('customForm', { static: true }) customFormRef: ElementRef;
 

  public onBeforeOnInit() {
    this.filter = {};
  }

  ngOnInit(): void {
    this.onBeforeOnInit();
    this.gridConfig = this.loadGridConfig();
    this.isPrototyping = this.appGlobal.get('prototyping');
    this.formConfig = this.getFormConfig(SecurityJson);
    console.log(this.formConfig);

  }

  private getFormConfig(securityJson: any) {
    this.local.formConfig = {};

    this.local.formConfig.dateRange = {
      security_code: 'dateRange',
      label: 'Created Date',
      type: 'daterange',
      name: 'dateRange',
      placeholder: '',
      infoBubble: '',
      values: [],
      options: [],
      disabled: false,
      toolbar: true,
      displayonly: false,
      validations: {
      },
      formAttributes: {
        change: this.handleCustomEvents.bind(this)
      },
    };

    // this.local.formConfig.modifiedDate = {
    //   security_code: 'modifiedDate',
    //   label: 'Modified Date',
    //   type: 'daterange',
    //   name: 'modifiedDate',
    //   placeholder: '',
    //   infoBubble: '',
    //   values: [],
    //   options: [],
    //   disabled: false,
    //   toolbar: true,
    //   displayonly: false,
    //   validations: {
    //   },
    //   formAttributes: {
    //     change: this.handleCustomEvents.bind(this)
    //   },
    // };

    this.local.formConfig.createdBy = {

      security_code: 'createdBy',
      label: 'Created By',
      type: 'text',
      name: 'createdBy',
      placeholder: '',
      
      infoBubble: '',
      values:[],
      options:[],
      disabled: false,
      toolbar: true,
      displayonly: false,
      formAttributes: {
        change: this.handleCustomEvents.bind(this)
      },


    };

    this.local.formConfig.userId = {

      security_code: 'userId',
      label: 'Search User ID',
      type: 'text',
      name: 'userId',
      placeholder: '',
      
      infoBubble: '',
      values:[],
      options:[],
      disabled: false,
      toolbar: true,
      displayonly: false,
      formAttributes: {
        change: this.handleCustomEvents.bind(this)
      },


    };

    this.local.formConfig.emailId = {

      security_code: 'emailId',
      label: 'Search Email ID',
      type: 'text',
      name: 'emailId',
      placeholder: '',
      
      infoBubble: '',
      values:[],
      options:[],
      disabled: false,
      toolbar: true,
      displayonly: false,
      formAttributes: {
        change: this.handleCustomEvents.bind(this)
      },


    };

    this.local.formConfig.controlGroupId = {

      security_code: 'controlGroupId',
      label: 'Search Control Group ID',
      type: 'text',
      name: 'controlGroupId',
      placeholder: '',
      
      infoBubble: '',
      values:[],
      options:[],
      disabled: false,
      toolbar: true,
      displayonly: false,
      formAttributes: {
        change: this.handleCustomEvents.bind(this)
      },
    };

    this.local.formConfig.result = {

      security_code: 'result',
      label: 'Search New Flag of the Result',
      type: 'select',
      name: 'result',
      placeholder: '',

      infoBubble: '',
      values: [],
      options: [{
        label: 'YES',
        value: 'YES'
      }, {
        label: 'NO',
        value: 'NO'
      }],
      disabled: false,
      toolbar: true,
      displayonly: false,
      validations: {
      },
      formAttributes: {
        change: this.handleCustomEvents.bind(this)
      },


    };

    return {
      initCallback: this.changeLogFormInitComplete.bind(this),
      collapsible: false,
      submit: 'saveBasicDetails',
      class: 'no-margin form-elements-group',
      securityEvaluation: this.hasWorkflow,
      staticSecurityJson: securityJson,
      disabledForm: false,
      columns: 100,
      groups: [
        {
          groupHeaderClass: 'form-group-subheader hidden',
          groupContentClass: 'paddingZero',
          collapsible: 'false',
          columns: '100',
          label: '',
          disableRights: false,
          columnsWidth: 10,
          items: [
            {


              groupHeaderClass: 'form-group-subheader hidden',
              groupContentClass: 'paddingZero',
              collapsible: 'false',
              columns: '25',
              label: '',
              disableRights: false,
              columnsWidth: 10,
              items: [
                this.local.formConfig.userId,
                this.local.formConfig.emailId,
                this.local.formConfig.controlGroupId,
                this.local.formConfig.result
              ]
            },
            {
              groupHeaderClass: 'form-group-subheader hidden',
              groupContentClass: 'paddingZero',
              collapsible: 'false',
              columns: '25',
              label: '',
              disableRights: false,
              columnsWidth: 10,
              items: [
                this.local.formConfig.createdBy,
                // this.local.formConfig.modifiedDate,
                this.local.formConfig.dateRange,
              ]
            },
            
            
            
          ]
        }
      ]
    };

  }

  private createRefresh(settings: any, json: any, dtTable: any) {
    this.refreshGridMethod = () => {
      this.gridComp.refreshGrid();
    };
  }

  public searchdata() {
    this.refreshGridMethod();
  }

  private loadGridConfig(): any {
    const self = this;

    const gridConfig: any = {
      autoWidth: false,
      ordering: this.isPrototyping ? true : false,
      customOrdering: this.isPrototyping ? false : true,
      columnDefs: [
        {
          "defaultContent": "",
          "targets": "_all"
        }
      ],
      columns: [
        {
          data: 'userId', name: 'user_id', title: 'User ID', type: 'string', width: '15%', render: (data: any, type: any, row: any) => {
            if (data != null) {
              return data || '';
            }
          }
        },
        {
          data: 'emailId', name: 'email-id', title: 'Email ID', type: 'string', width: '25%', render: (data: any, type: any, row: any) => {
            if (data != null) {
              return data || '';
            }
          }
        },
        {
          data: 'controlGroupId', name: 'control_group_id', title: 'Control Group ID', width: '15%', type: 'string', render: (data: any, type: any, row: any) => {
            if (data != null) {
              return data || '';
            }
          }
        },
        {
          data: 'result', name: 'result', title: 'New Flag of the Result', width: '10%', type: 'string', conditionalColorField: 'result',
          conditionalColor: {
            'YES': 'results-result-yes',
            'NO': 'results-result-no',
          },
        },
        { data: 'createDate', name: 'createDate', width: '10%', title: 'Created Date', type: 'date' },
        {
          data: 'createdBy', name: 'createdBy', title: 'Created By', type: 'string', width: '25%', render: (data: any, type: any, row: any) => {
            if (data != null) {
              return data || '';
            }
          }
        }
      ],
      searchMandatory: true,
      emptyTableMsg: "Please search by filters to get data",
      infoEmpty: "No matching results, please try a different search",
      disableSelection: true,
      onRowSelect: (selectedRows: any, id: any) => {
      },
      onRowDeselect: (selectedRows: any) => {
      },
      onInitComplete: (dtTable: any, settings: any, json: any) => {
        self.dtTable = dtTable;
        self.createRefresh(settings, json, dtTable);
        //setTimeout(() => {
        self.setGridHeight(settings, json, dtTable);
        //}, 1000);
      },
      fnServerParams: (searchObj) => {
        return this.extendFnServerParams(searchObj);
      },
      onBeforeGridServiceRequest: (params: any, isFromSort: boolean, isFromRefresh: boolean) => {
      },
      onAfterGridServiceResponse: (params: any, isFromSort: boolean, isFromRefresh: boolean, data: any) => {
      },
      onRowCreate: (row: any, data: any, dataIndex: any) => {
      },
      onRowClick: (event: any, id: any) => {

      },
      drawCallback: (settings: any) => {
      },
      headerCallback: (thead: any, data: any, start: any, end: any, display: any) => {
      },
      preDrawCallback: (settings: any) => {
      },
      rowCallback: (row: any, data: any, index: any) => {
      },
      maxRowsAllowedForSelection: AppConstants.maxRowsAllowedToSelect,
      rowMenuOptions: [
      ],
      beforeRowMenuShow: (option: any, data: any, row: any) => {
      },
      onRowMenuClick: (option: any, row: any, data: any) => {
      },
      onMobileRowDisplay: (row: Node, data: any[] | object, index: number) => {
        return row;
      },
      complexHeader: [
      ]
    };


    gridConfig.scrollY = self.getGridHeight();

    if (this.isPrototyping) {
      gridConfig.method = 'get';
      gridConfig.ajaxUrl = '/assets/data/Results.json';

    } else {
      gridConfig.ajaxMethod = 'POST';
      gridConfig.ajaxUrl = '/' + AppConstants.apihost + '/' + ApiConstants.getChangeLog.url;
    }

    return gridConfig;
  }

  private getGridHeight() {
    const currentEl = this.element.nativeElement;
    const gridEl = currentEl.querySelector('app-vs-grid');
    const gridElOffsetTop = gridEl.querySelector('div').offsetTop + (AppConstants.isMobile ? 40 : 90);
    let gridHeight = window.innerHeight - gridElOffsetTop;
    return gridHeight;
  }

  private setGridHeight(settings: any, json: any, dtTable: any) {
    const gridHeight = this.getGridHeight();
    $(settings.nScrollBody).css({ height: gridHeight + 'px', 'max-height': gridHeight + 'px' });
  }

  public handleCustomEvents(e: Event, form?: any) { }

  public changeLogFormInitComplete(form: any) {
  }

  public extendFnServerParams(searchObj) {
    if (Object.keys(this.filter).length > 0) {
      $.extend(searchObj, this.filter);
    }

    if (this.child != null && this.child.form != null && this.child.form.value) {
      if (this.child.form.value.userId == null) {
        this.child.form.value.userId = '';
      }
      if (this.child.form.value.emailId == null) {
        this.child.form.value.emailId = '';
      }
      if (this.child.form.value.controlGroupId == null) {
        this.child.form.value.controlGroupId = '';
      }
      if (this.child.form.value.result == null) {
        this.child.form.value.result = '';
      }
      if (!this.child.form.value.createdBy) {
        this.child.form.value.createdBy = '';
      }
      searchObj =
      {
        'dateRange': this.getFormattedDate(this.child.form.value.dateRange?.from) +',' + this.getFormattedDate(this.child.form.value.dateRange?.to),
        'userId': this.child.form.value.userId,
        'emailId': this.child.form.value.emailId,
        'controlGroupId': this.child.form.value.controlGroupId,
        'result': this.child.form.value.result,
        // 'modifiedDate': this.getFormattedDate(this.child.form.value.modifiedDate?.from) +',' + this.getFormattedDate(this.child.form.value.modifiedDate?.to),
        'createdBy': this.child.form.value.createdBy
      }

      if (!this.child.form.value.dateRange || !this.child.form.value.dateRange.from || !this.child.form.value.dateRange.to) {
        delete searchObj.dateRange;
      }

      if (!this.child.form.value.userId) {
        delete searchObj.userId;
      }
      if (!this.child.form.value.emailId) {
        delete searchObj.emailId;
      }
      if (!this.child.form.value.controlGroupId) {
        delete searchObj.controlGroupId;
      }
      if (!this.child.form.value.result) {
        delete searchObj.result;
      }
      // if (!this.child.form.value.modifiedDate || !this.child.form.value.modifiedDate.from || !this.child.form.value.modifiedDate.to) {
      //   delete searchObj.modifiedDate;
      // }
      if (!this.child.form.value.createdBy) {
        delete searchObj.createdBy;
      }
    }
    //TODO -  pass filter data in search
    return searchObj;
  }

  public export(config: any) {
    let co = {
      header: 'Confirm?',
      message: 'Are you sure you want to export the file?',
      prop: null,
      buttons: null,
      methods: null
    };
    const confirm = this.modalPopupService.openConfirmationModal(co.header, co.message, co.prop, co.buttons, co.methods);
    confirm.subscribe((isConfirmed: boolean) => {
      if (isConfirmed) {

        if (this.child != null && this.child.form != null && this.child.form.value) {
          if (this.child.form.value.userId == null) {
            this.child.form.value.userId = '';
          }
          if (this.child.form.value.emailId == null) {
            this.child.form.value.emailId = '';
          }
          if (this.child.form.value.controlGroupId == null) {
            this.child.form.value.controlGroupId = '';
          }
          if (this.child.form.value.result == null) {
            this.child.form.value.result = '';
          }
          if (!this.child.form.value.createdBy) {
            this.child.form.value.createdBy = '';
          }
          let searchObj =
          {
            'dateRange': this.getFormattedDate(this.child.form.value.dateRange?.from) +',' + this.getFormattedDate(this.child.form.value.dateRange?.to),

            'userId': this.child.form.value.userId,
            'emailId': this.child.form.value.emailId,
            'controlGroupId': this.child.form.value.controlGroupId,
            'result': this.child.form.value.result,
            // 'modifiedDate': this.getFormattedDate(this.child.form.value.modifiedDate?.from) +',' + this.getFormattedDate(this.child.form.value.modifiedDate?.to),
            'createdBy': this.child.form.value.createdBy
          }
    
          if (!this.child.form.value.dateRange || !this.child.form.value.dateRange.from || !this.child.form.value.dateRange.to) {
            delete searchObj.dateRange;
          }
    
          if (!this.child.form.value.userId) {
            delete searchObj.userId;
          }
          if (!this.child.form.value.emailId) {
            delete searchObj.emailId;
          }
          if (!this.child.form.value.controlGroupId) {
            delete searchObj.controlGroupId;
          }
          if (!this.child.form.value.result) {
            delete searchObj.result;
          }
          // if (!this.child.form.value.modifiedDate || !this.child.form.value.modifiedDate.from || !this.child.form.value.modifiedDate.to) {
          //   delete searchObj.modifiedDate;
          // }
          if (!this.child.form.value.createdBy) {
            delete searchObj.createdBy;
          }
          this.customService.getChangeLogExcel(searchObj).subscribe(response => {
            console.log(response);

            this.notification.success("Export has been initiated. You will receive Email in few seconds.");

          }, err => {
            console.log("error coming in")
            this.notification.error("Export failed.", err);
          });
        }
      }
    });
  }

  private zeroPadding = (num, places) => String(num).padStart(places, '0');

  public getFormattedDate(data: any) {
    if(!data) {
      return data;
    }

    const date = new Date(data);

    if (date.toLocaleDateString() != 'Invalid Date') {
      return date.getFullYear() + '-' + this.zeroPadding(date.getMonth() + 1, 2) + '-' + this.zeroPadding(date.getDate(),2);
    }

    if(date.toLocaleDateString() != 'Invalid Date') {
      return date.toISOString().split('T')[0]
    }
    
    return null;
  }

}
